import React, {Component} from 'react';

export default class AnimatedCard extends Component {
    render() {
        const {animation, digit} = this.props;

        return (
            <div className={`flipCard ${animation} font-bold`}>
                <span>{digit}</span>
            </div>
        );
    };
}
